require("!!C:\\Vadim\\Projects\\Php\\zakupki\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Vadim\\Projects\\Php\\zakupki\\node_modules\\raw-loader\\index.js!C:\\Vadim\\Projects\\Php\\zakupki\\assets\\vendor\\sock-js\\sockjs-0.3.min.js"))


//////////////////
// WEBPACK FOOTER
// ../vendor/sock-js/sockjs-0.3.min.js
// module id = ivAU
// module chunks = 3 4 5 20 29